import { render, staticRenderFns } from "./StatementForwarding.vue?vue&type=template&id=58e7a950&"
import script from "./StatementForwarding.vue?vue&type=script&lang=js&"
export * from "./StatementForwarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports